export default __webpack_public_path__ + "static/media/sacred_logo.999299bd.png";